<template>
    <div>
        <app-header
            :step="currentStep"
            :steps="totalSteps"
            :productData="productData"
            :initialProductData="initialProductData"
            :dealerID="dealerID"
            :staticContent="staticContent"
            @updateStepHandler="updateStep"
            @updateSlugTriggered="resetProduct">
        </app-header>
        <div :class="['panel', selectorPanelIsOpen ? 'is-open' : 'is-closed']" v-if="product">
            <transition name="fade" duration="400">
                <div class="loader" v-if="isLoading || isUpdatingStep">
                    <div class="loader-animation"></div>
                    <h2 class="loader-text" v-if="isLoadingFirstTime">{{ staticContent.loading }}</h2><!-- /.loader-text -->
                </div>
            </transition>
            <div :class="['panel__main', isLoading && !isUpdatingStep && productData ? 'is-loading' : '']">
                <div class="select-product" v-if="!mailResponse">
                    <transition mode="in-out" :name="currentStep >= lastStep ? 'next-slide' : 'prev-slide'" :duration="{ enter: 800, leave: 400 }">
                        <div class="blocks-wrapper" v-if="!isUpdatingStep">
                            <template v-for="(block) in content.blocks">
                                <div class="panel__top" v-if="block.itemType === 'Block'">
                                    <h1 class="panel-title" v-if="block.title" v-html="block.title"></h1>
                                    <div class="panel-description" v-if="block.description" v-html="block.description"></div>
                                </div>
                                <div
                                    :class="['block', !block.isValid ? 'block--error' : '']"
                                    v-else-if="block.itemType === 'ListProperty'">
                                    <div class="block__top">
                                        <h2 class="block-title" v-if="block.title">
                                            {{ block.title }}
                                            <button
                                                v-if="block.description"
                                                @click="openContentModal"
                                                class="btn-help"
                                                :data-html="block.description">
                                            </button>
                                        </h2>
                                    </div><!-- /.block__top -->
                                    <div class="block__main block__main--options">
                                        <ul :class="['option-list', block.listClass]">
                                            <li v-for="(option) in block.options" :key="option.key" :class="['list-item', ...option.classes]">
                                                <input
                                                    type="radio"
                                                    :checked="option.selected"
                                                    :id="option.id"
                                                    :value="option.key"
                                                    :name="block.name"
                                                    :disabled="isLoading"
                                                    @change="onInputChange($event, block, option)">
                                                <label :for="option.id"></label>
                                                <div class="list-item__image">
                                                    <div class="image-wrapper">
                                                        <img :src="option.data.thumbnail" alt="" @load="(event)=> {event.target.classList.add('has-loaded') }">
                                                    </div><!-- /.image-wrapper -->
                                                </div><!-- /.list-item__image -->
                                                <div class="list-item__content">
                                                    <div class="list-item-title" v-if="option.data.title">
                                                        <span v-html="option.data.title"></span>
                                                        <button
                                                            v-if="option.data.image"
                                                            @click="openContentModal"
                                                            class="btn-magnify"
                                                            :data-image="option.data.image">
                                                        </button>
                                                    </div>
                                                    <div class="list-item-video" v-if="option.data.video">
                                                        <a
                                                            @click="openContentModal"
                                                            class="btn-video"
                                                            :data-video="option.data.video">
                                                            Bekijk de video
                                                        </a>
                                                    </div><!-- /.list-item-video -->
                                                </div><!-- /.list-item__content -->
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="block__messages" v-if="block.messages.length > 0">
                                        <ul>
                                            <li v-for="(message) in block.messages" :class="message.className" :key="message.blockElementId">{{message.text}}</li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="block" v-else-if="block.itemType === 'RoomSelector'">
                                    <div class="block__main">
                                        <ul :class="['option-list', block.listClass]">
                                            <li v-for="(option) in block.customOptions" :key="option.key" :class="['list-item', option.selected ? 'selected' : '']">
                                                <input
                                                    type="radio"
                                                    :class="option.selected ? 'selected' : ''"
                                                    :checked="option.selected"
                                                    :id="option.key"
                                                    :value="option.value"
                                                    :name="block.name"
                                                    :disabled="isLoading"
                                                    @change="onRoomChange($event, option.key)">
                                                <label :for="option.key"></label>
                                                <div class="list-item__image">
                                                    <div class="image-wrapper">
                                                        <img :src="option.thumb" alt="" @load="(event)=> {event.target.classList.add('has-loaded') }">
                                                    </div><!-- /.image-wrapper -->
                                                </div><!-- /.list-item__image -->
                                                <div class="list-item__content">
                                                    <h4>
                                                        {{ option.data.title }}
                                                    </h4>
                                                </div><!-- /.list-item__content -->
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div v-else-if="block.itemType === 'RoomColorSelector'">
                                    <div class="block__top">
                                        <h1 class="block-title" v-if="block.title">{{ block.title }}</h1>
                                        <div class="block-description" v-if="block.description" v-html="block.description"></div>
                                    </div>
                                    <div class="block__main">
                                        <ul :class="['option-list', block.listClass]">
                                            <li v-for="(option) in block.customOptions" :key="option.color" class="list-item" :class="option.selected ? 'selected' : ''">
                                                <input
                                                    type="radio"
                                                    :checked="option.selected"
                                                    :class="option.selected ? 'selected' : ''"
                                                    :id="option.color"
                                                    :value="option.color"
                                                    :name="block.name"
                                                    :disabled="isLoading"
                                                    @change="onRoomColorChange(option.color)">
                                                <label :for="option.color"></label>
                                                <div class="list-item__image" :style="{ backgroundColor: option.color}"></div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="block" v-else-if="block.itemType === 'SummaryBlock'">
                                    <div class="block__top">
                                        <h2 class="block-title" v-if="block.title" v-html="block.title"></h2>
                                    </div><!-- /.block__top -->
                                    <div class="block__main">
                                        <ul class="summary-list">
                                            <li v-for="(summaryItem) in block.summaryItems" :key="summaryItem.blockElementId" class="list-item">
                                                <div class="list-item__name">{{ summaryItem.title }}</div>
                                                <div class="list-item__value" v-html="summaryItem.value"></div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div :class="['block', !block.isValid ? 'block--error' : '']" v-else-if="block.itemType === 'BooleanProperty'">
                                    <div class="block__main block__main--boolean custom-form">
                                        <input
                                            type="checkbox"
                                            :id="block.id"
                                            :checked="block.value"
                                            :value="!block.value"
                                            :name="block.name"
                                            :disabled="isLoading"
                                            @change="onInputChange($event, block)">
                                            <label :for="block.id">{{ block.title }}</label>
                                            <button
                                                v-if="block.description"
                                                @click="openContentModal"
                                                class="btn-help"
                                                :data-html="block.description">
                                            </button>
                                    </div>
                                    <div class="block__messages" v-if="block.messages.length > 0">
                                        <ul>
                                            <li v-for="(message) in block.messages" :class="message.className" :key="message.blockElementId">{{message.text}}</li>
                                        </ul>
                                    </div>
                                </div>
                                <div :class="['block', !block.isValid ? 'block--error' : '']" v-else-if="block.itemType === 'IntegerProperty'">
                                    <div class="block__top">
                                        <h2 class="block-title" v-if="block.title">
                                            {{ block.title }}
                                            <button
                                                v-if="block.description"
                                                @click="openContentModal"
                                                class="btn-help"
                                                :data-html="block.description">
                                            </button>
                                        </h2>
                                    </div><!-- /.block__top -->
                                    <div class="block__main block__main--integer custom-form">
                                        <input
                                            type="number"
                                            :value="block.value"
                                            :id="block.id"
                                            :name="block.name"
                                            :disabled="isLoading"
                                            @change="onInputChange($event, block)"
                                            onfocus="this.select();">
                                    </div>
                                    <div class="block__messages" v-if="block.messages.length > 0">
                                        <ul>
                                            <li v-for="(message) in block.messages" :class="message.className" :key="message.blockElementId">{{message.text}}</li>
                                        </ul>
                                    </div>
                                </div>
                            </template>
                        </div><!-- /.blocks-wrapper -->
                    </transition>
                </div><!-- /.select-product -->
                <div class="mailresult" v-else>
                    <h2>{{ mailResponseContent.title }}</h2>
                    <div v-if="mailResponseContent.message" v-html="mailResponseContent.message"></div>
                    <button :disabled="isLoading" @click="reset" class="btn btn--1" v-if="mailResponseContent.success">{{ mailResponseContent.btnText }}</button>
                    <button :disabled="isLoading" @click="mailResponse = false" class="btn btn--2" v-else>{{ mailResponseContent.btnText }}</button>
                </div><!-- /.mailresult -->
            </div><!-- /.panel__main -->
            <div class="panel__bottom" v-if="productData && mailResponse === false">
                <div class="btn-container">
                    <button
                        @click="prevStep"
                        :disabled="isLoading || currentStep === 0"
                        class="btn btn--2 btn--prev">
                        <svg class="icon" width="11" height="20" viewBox="0 0 11 20" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1l9 9-8.999 9" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                        {{ staticContent.previous }}
                    </button>
                    <button
                        @click="nextStep"
                        v-if="currentStep !== totalSteps"
                        :disabled="isLoading || !productData.blockElements[currentStep].isValid"
                        class="btn btn--1 btn--next">
                        {{ staticContent.next }}
                        <svg class="icon" width="11" height="20" viewBox="0 0 11 20" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1l9 9-8.999 9" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </button>
                    <button
                        @click="reset"
                        v-if="currentStep === totalSteps"
                        :disabled="isLoading"
                        class="btn btn--4">
                        {{ staticContent.reset }}
                    </button>
                </div><!-- /.btn-container -->
                <div class="mail-form custom-form" v-if="currentStep === totalSteps">
                    <form @submit="submitMailForm">
                        <ul>
                            <li class="mail-form__label">
                                <label for="mail-form-input">{{ staticContent.emailLabel }}</label>
                            </li>
                            <li class="mail-form__input">
                                <input type="email" id="mail-form-input" :placeholder="staticContent.emailPlaceholder" v-model="mailAddressee">
                                <button class="btn btn--1 btn--icon" type="submit">
                                    <span class="icon icon-email">
                                        <svg id="b025f25b-0cac-4704-a459-a2bea3a1cac1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="32" height="24" viewBox="0 0 32 24">
                                            <g id="b072d0b9-8add-41c7-913c-9ae87f64ccd4" data-name="envelope">
                                                <g id="a9c40cdd-401b-414f-9202-73ea1e23f91d" data-name="Stroke-1">
                                                    <path d="M32,24H0V0H32ZM2,22H30V2H2Z" />
                                                </g>
                                                <g id="aea0f145-51e5-4969-a08f-145fd4eb2067" data-name="Stroke-3">
                                                    <rect x="24.5" y="7.57" width="2" height="14.87" transform="translate(-2.75 23.78) rotate(-47.72)" />
                                                </g>
                                                    <rect x="-0.93" y="14" width="14.87" height="2" transform="translate(-8.4 8.27) rotate(-42.27)" />
                                                <g id="ade64c25-0050-43cc-b82f-e11642b7e8eb" data-name="Stroke-4">
                                                    <path d="M16,13a5.38,5.38,0,0,1-3.1-1L.41,2.81,1.59,1.19l12.49,9.16a3.16,3.16,0,0,0,3.84,0L30.41,1.19l1.18,1.62L19.1,12A5.36,5.36,0,0,1,16,13Z" />
                                                </g>
                                            </g>
                                        </svg>
                                    </span>
                                    {{ staticContent.emailButton }}
                                </button>
                            </li>
                        </ul>
                    </form>
                </div><!-- /.mail-form -->
            </div>
            <button class="toggle-btn" @click="toggleSelectorPanel">
                <svg width="11" height="20" viewBox="0 0 11 20" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1l9 9-8.999 9" stroke-width="2" stroke="#555" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
            </button>
        </div>
        <a :href="$route.query.back_url" class="btn btn--5 btn--prev btn--back-btn" v-if="$route.query.back_url">
            <svg class="icon" width="11" height="20" viewBox="0 0 11 20" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1l9 9-8.999 9" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            {{ this.$route.query.back_label ? this.$route.query.back_label : 'Ga terug' }}
        </a>
        <app-modal :showModal="!slug" customClass="product-selector">
            <template slot="modal-header">
                <h1>{{ staticContent.productSelect }}</h1>
                <button class="close-btn" @click="hideSubProducts" v-if="subProducts">
                    <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13 1L1 13M1 1l12 12" stroke="#555" stroke-width="2" fill="none" fill-rule="evenodd" opacity=".332"></path>
                    </svg>
                </button>
            </template>
            <template slot="modal-body">
                <div class="loader" v-if="!initialProductData">
                    <div class="loader-animation"></div>
                </div>
                <ul class="products" v-if="initialProductData" :class="{ 'is-hidden': subProducts }">
                    <li class="product" v-for="product in topLevelProducts" :key="product.ID">
                        <router-link tag="a" :to="'/product/' + product.slug" v-if="!product.sub">
                            <h3 v-html="product.productTitle"></h3>
                            <img
                                :src="product.productImg"
                                :width="product.productImgWidth"
                                :height="product.productImgHeight" />
                        </router-link>
                        <a role="button"
                            v-else
                            @click="showSubProducts(product.ID)"
                        >
                            <h3 v-html="product.productTitle"></h3>
                            <img
                                :src="product.productImg"
                                :width="product.productImgWidth"
                                :height="product.productImgHeight"
                            />
                        </a>
                    </li>
                </ul><!-- /.products -->
                <transition name="fade">
                    <div class="sub-products__container" v-if="subProducts">
                        <ul class="sub-products">
                            <li v-for="product in subProducts" :key="product.id">
                                <router-link tag="a" :to="'/product/' + product.slug" v-if="!product.sub">
                                <h3 v-html="product.productTitle"></h3>
                                <img :src="product.productImg" :width="product.productImgWidth" :height="product.productImgHeight" />
                            </router-link>
                            </li>
                        </ul><!-- /.sub-products -->
                    </div><!-- /.sub-products__container -->
                </transition>
            </template>
        </app-modal>
        <app-modal
            :showModal="modal.isOpen"
            closeBtn="true"
            @closeModalClickedHandler="modal.isOpen = false"
            class="js-content-modal">
            <template slot="modal-body">
                <img class="modal__image" v-if="modal.image" :src="modal.image" />
                <!-- To do: video optie implementeren -->
                <div class="modal__html" v-if="modal.html" v-html="modal.html"></div>
                <div class="modal__video" v-if="modal.video">
                    <div class="embed-container">
                        <iframe width="560" height="315" :src="modal.video + '?rel=0&amp;showinfo=0&autoplay=1'" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                    </div><!-- /.embed-container -->
                </div>
            </template>
        </app-modal>
        <app-modal :showModal="sessionExpired" customClass="modal--session-expired">
            <template slot="modal-header">
                <h1>Sessie verlopen</h1>
            </template>
            <template slot="modal-body">
                <button class="btn btn--1" @click="init">Sessie herstellen</button>
            </template>
        </app-modal>
        <div class="background">
            <transition name="fade" duration="800">
                <div v-if="productData" v-show="!mainImgLoading" class="background__image" :style="mainBackground">
                    <img @load="mainImgLoaded" :src="product.selectedImage" />
                </div><!-- /.background__image -->
            </transition>
        </div>
    </div>
</template>
<script>
    import $ from 'jquery';
    import api from '../api';
    import router from '../router';
    import Header from '../components/header.vue';
    import Modal from '../components/modal.vue';

    export default {
        data() {
            return {
                isLoading: true,
                isLoadingFirstTime: true,
                loadingInterval: null,
                isUpdatingStep: false,
                staticSteps: false,
                sessionExpired: false,
                selectorPanelIsOpen: true,
                modal: {
                    isOpen: false,
                    image: null,
                    video: null,
                    html: null
                },
                oAuthToken: '',
                productData: null,
                dealerID: this.$route.query.dealer_id,
                currentStep: 0,
                lastStep: 0,
                content: {
                    savedBlocks: null,
                    blocks: []
                },
                initialProductData: null,
                slug: this.$route.params.slug,
                selectedRoomIndex: 0,
                selectedRoomColor: null,
                roomSelector: null,
                roomOptions: null,
                roomColorOptions: null,
                mainImgLoading: true,
                mainImgBackgroundColorFirst: null,
                mainImgBackgroundColorSecond: null,
                mailAddressee: null,
                mailUrl: null,
                mailResponse: false,
                mailResponseContent: null,
                staticContent: {},
                subProducts: null
            }
        },
        computed: {
            topLevelProducts() {
                return this.initialProductData.filter(product => !product.parent);
            },
            subLevelProducts() {
                return this.initialProductData.filter(product => product.parent);
            },
            totalSteps: function () {
                if (this.productData) {
                    return this.productData.blockElements.length - 1;
                } else {
                    return 0;
                }
            },
            product: function () {
                if ( this.slug && this.initialProductData) {
                    return this.initialProductData.find(product => product.slug === this.slug);
                } else {
                    return null;
                }
            },
            json: function() {
                const summaryBlock = this.productData.blockElements.find(blockElement => blockElement.name === 'summary')
                return JSON.stringify(Object.assign(summaryBlock, {
                    room_image: this.product.selectedImage,
                    prod_color: this.mainImgBackgroundColorFirst,
                    price: this.price,
                    dealer_id: this.dealerID,
                }));
            },
            mainBackground() {
                if ( this.mainImgBackgroundColorFirst && !this.mainImgBackgroundColorSecond ) {
                    return 'background-color: ' + this.mainImgBackgroundColorFirst;
                } else if ( this.mainImgBackgroundColorFirst && this.mainImgBackgroundColorSecond ) {
                    const degrees = this.product.rooms.rooms[this.selectedRoomIndex].multipleFabricDegrees;
                    const percentage = this.product.rooms.rooms[this.selectedRoomIndex].multipleFabricPercentage;
                    return 'background: linear-gradient(' + degrees + 'deg, ' + this.mainImgBackgroundColorFirst + ' ' + percentage + '%, ' + this.mainImgBackgroundColorSecond + ' 0% );'
                }
            }
        },
        watch: {
            $route: function () {
                this.slug = this.$route.params.slug;
                this.selectProduct();
            },
            currentStep: function (currentStep, lastStep) {
                this.lastStep = lastStep;
                this.isUpdatingStep = true;
            }
        },
        components: {
            'appHeader': Header,
            'appModal': Modal
        },
        methods: {
            init() {
                // this.staticContent.loading = this.staticContent.loadingTxts[0];
                api.getOAthToken()
                    .done(data => {
                        this.oAuthToken = data.access_token;
                        this.sessionExpired = false;
                        // this.staticContent.loading = this.staticContent.loadingTxts[];

                        if ( !this.productData ) {
                            this.selectProduct();
                        }
                    })
                    .fail( error => {
                        console.log('no token found');
                    });
            },
            rotateLoadingTxts() {
                const nrOfItems = this.staticContent.loadingTxts.length;
                let activeItem  = 0;
                let intervalTime = Math.floor(Math.random() * 1300) + 600;

                this.loadingInterval = setInterval(() => {
                    if ( activeItem < nrOfItems ) {
                        this.staticContent.loading = this.staticContent.loadingTxts[activeItem];
                        activeItem++;

                        if ( Math.random() > 0.5) {
                            // lengthen interval time
                            intervalTime = intervalTime + ( Math.floor(Math.random() * 350) + 150 );
                        } else {
                            // shorten interval time
                            intervalTime = intervalTime - ( Math.floor(Math.random() * 350) + 150 );
                        }

                    } else {
                        clearInterval(this.loadingInterval);
                    }
                }, intervalTime);
            },
            resetProduct() {
                this.currentStep = 0;
                this.lastStep = 0;
                this.mainImgBackgroundColorFirst = null;
                this.mainImgBackgroundColorSecond = null;
                this.selectedRoomIndex = 0;
                this.selectedRoomColor = null;
                this.isLoading = true;
                this.isLoadingFirstTime = true;
                this.productData = null;
                this.roomOptions = null;
                this.roomColorOptions = null;
                this.isUpdatingStep = false;
                this.content = {
                    savedBlocks: null,
                    blocks: []
                };
                this.mainImgLoading = true;
                this.staticSteps = false;
                this.mailResponse = false;
                this.mailResponseContent = null;
                this.roomSelector = null;
            },
            reset() {
                router.push({ path: '/' });
                this.resetProduct('');
            },
            resetScrollPosition() {
                const panel = document.querySelector('.panel__main');
                panel.scrollTop = 0;
            },
            prevStep() {
                this.currentStep--;
                this.updateStep();
            },
            nextStep() {
                this.currentStep++;
                this.updateStep();
            },
            updateStep(newStepIndex) {
                if (this.currentStep === newStepIndex) return false
                if (newStepIndex) this.currentStep = newStepIndex;
                this.productData.blockElements[this.currentStep].visited = true;
                this.updateProductData();

                setTimeout(() => {
                    this.resetScrollPosition();
                }, 500);
            },
            selectProduct() {
                if (this.product) {
                    this.product.selectedImage = this.product.rooms.rooms[0].colors[0].mainImage;
                    this.selectedRoomColor = this.product.rooms.rooms[0].colors[0].color;

                    this.staticContent.loadingTxts = this.product.loadingTxts;

                    if ( this.staticContent.loadingTxts ) {
                        this.staticContent.loading = this.staticContent.loadingTxts[0];
                        this.rotateLoadingTxts();
                    }

                    api.selectProduct(this.product.productID, this.oAuthToken)
                    .done(productData => {
                        this.content.savedBlocks = [];
                        this.updateProductData(productData);
                    })
                    .fail(error => {
                        if ( error.status === 401 ) {
                            console.log('Uw sessie is verlopen!');
                            this.sessionExpired = true;

                            if ( this.staticContent.loadingTxts ) {
                                this.staticContent.loading = this.staticContent.loadingTxts[0];
                            }

                            clearInterval(this.loadingInterval);
                        }
                    });
                }
            },
            showSubProducts(parentID) {
                this.subProducts = this.initialProductData.filter(product => product.parent === parentID);
            },
            hideSubProducts() {
                this.subProducts = null;
            },
            toDataURL(url, callback) {
                var httpRequest = new XMLHttpRequest();
                httpRequest.onload = function() {
                    var fileReader = new FileReader();
                    fileReader.onloadend = function() {
                        callback(fileReader.result);
                    }
                    fileReader.readAsDataURL(httpRequest.response);

                };
                httpRequest.open('GET', url);
                httpRequest.responseType = 'blob';
                httpRequest.send();
            },
            setMainBackgroundColor(color, number) {

                if ( number === 1 ) {
                    this.mainImgBackgroundColorFirst = color;
                } else if ( number === 2 ) {
                    this.mainImgBackgroundColorSecond = color;
                }
            },
            updateProductData(productData, triggerIsListItemChange) {
                this.isLoading = true;

                if (!productData) {
                    productData = this.productData;
                } else {
                    this.staticSteps = false;
                }

                if (!this.staticSteps) {
                    addStaticSteps.call(this);
                }

                function addStaticSteps() {
                    // Add static block element

                    if ( !this.roomSelector ) {
                        const roomSelector = {
                            title: this.product.rooms.title,
                            description: this.product.rooms.description,
                            itemType: 'Block',
                            name: 'room-selector',
                            isValid: true,
                            rooms: this.initialProductData[0].rooms,
                            colors: this.initialProductData[0].rooms.colors,
                            blockElements: [
                                {
                                    itemType: 'RoomSelector',
                                    name: 'room',
                                    listClass: 'option-list--cards',
                                    customOptions: this.product.rooms.rooms.map((room, index) => {
                                        return {
                                            thumb: room.thumbnail,
                                            image: room.colors[0].mainImage,
                                            selected: index === 0 ? true : false,
                                            key: room.key,
                                            value: index,
                                            data: {
                                                title: room.title
                                            }
                                        }
                                    })
                                },
                                {
                                    title: this.product.rooms.colors.title,
                                    description: this.product.rooms.colors.description,
                                    itemType: 'RoomColorSelector',
                                    name: 'room-color',
                                    listClass: 'option-list--smaller',
                                    customOptions: this.product.rooms.colors.colors.map((color, index) => {
                                        return {
                                            color: color,
                                            selected: index === 0 ? true : false
                                        }
                                    })
                                }
                            ]
                        }

                        const roomSelectorOptions   = roomSelector.blockElements.find(element => element.itemType === 'RoomSelector');
                        this.roomOptions            = roomSelectorOptions.customOptions;
                        const roomColorOptions      = roomSelector.blockElements.find(element => element.itemType === 'RoomColorSelector');
                        this.roomColorOptions       = roomColorOptions.customOptions;

                        productData.blockElements.unshift(roomSelector);
                        this.roomSelector = roomSelector;
                    } else {
                        productData.blockElements.unshift(this.roomSelector);
                    }


                    // Add overview block element
                    const overview = {
                        title: this.staticContent.summaryTitle,
                        description: '<p>' + this.staticContent.summaryContent + '</p>',
                        name: 'summary',
                        itemType: 'Block',
                        isValid: true,
                    }

                    productData.blockElements.push(overview)

                    this.staticSteps = true;
                }

                // Add content to contentItems
                productData = addContentProviders.call(this, productData);

                function addContentProviders(blockData, stepIndex) {
                    if (blockData.blockElements) {
                        blockData.blockElements = blockData.blockElements.map((blockElement, index) => {

                            // Add stepIndex to blockElements
                            if (!stepIndex) stepIndex = 0;
                            if (blockElement.itemType === 'Block') {
                                stepIndex = index;
                                blockElement.isValid = true;
                            }
                            blockElement.stepIndex = stepIndex;

                            // Set id to name if there is no id
                            if (!blockElement.id) blockElement.id = blockElement.name;

                            // Add error messages to blockElement
                            if (productData.messages) {
                                blockElement.messages = productData.messages.filter(message => {
                                    if (message.severity === 0) {
                                        message.className = 'info'
                                    } else if (message.severity === 1) {
                                        message.className = 'warning'
                                    } else if (message.severity === 2) {
                                        message.className = 'error'
                                    }
                                    return message.blockElementId === blockElement.id;
                                })
                            } else {
                                blockElement.messages = []
                            }

                            // Set step to invalid if errorMessage has severity 2
                            const blockElementIsValid = !blockElement.messages.some(message => {
                                return message.severity === 2;
                            });

                            if (!blockElementIsValid) {
                                productData.blockElements[blockElement.stepIndex].isValid = false;
                            }

                            // Add contentProvider to option
                            if (blockElement.options) {
                                blockElement.options.forEach(option => {
                                    if (option.contentItems) {
                                        option.contentItems.forEach(addContentProvider);
                                    }
                                })
                            }

                            // Add contentProvider to contentItem
                            if (blockElement.contentItems) {
                                blockElement.contentItems.forEach(addContentProvider);

                                // Sort contentItems to new index
                                blockElement.contentItems = blockElement.contentItems.sort((a, b) => {
                                    return a.contentProvider.index - b.contentProvider.index
                                });
                            }

                            // Merge saved block to blockElement
                            const savedBlock = this.content.savedBlocks.find((block) => block.id === blockElement.id)
                            if (savedBlock) blockElement = Object.assign(blockElement, savedBlock)

                            // Function to add contentProvider to contentItem
                            function addContentProvider(contentItem) {

                                var tempContentProvider = productData.contentProviders.find((contentProvider, index) => {
                                    contentProvider.index = index;
                                    return contentProvider.id === contentItem.contentProviderId;
                                });

                                contentItem.contentProvider = {
                                    index: tempContentProvider ? tempContentProvider.index : null,
                                    url: tempContentProvider ? tempContentProvider.url : null,
                                    contentType: tempContentProvider ? tempContentProvider.contentType : null,
                                    contentProviderType: tempContentProvider ? tempContentProvider.contentProviderType : null
                                };

                                contentItem.type = contentItem.contentProvider.contentType;

                                if (contentItem.parameterValues && contentItem.parameterValues.length) {
                                    contentItem.parameterValues.forEach(function(parameterValue) {
                                        contentItem.contentProvider.url = contentItem.contentProvider.url.replace('{' + parameterValue.name + '}', parameterValue.value);
                                    });
                                }
                            }

                            // Repeat convertBlockData if blockElement has blockElements
                            if (blockElement.blockElements) blockElement = addContentProviders.call(this, blockElement, stepIndex)

                            return blockElement;
                        })
                    }
                    return blockData;
                }
                this.fetchData(productData, triggerIsListItemChange);
            },
            fetchData(productData, triggerIsListItemChange) {
                let promises = [];

                fetchBlockData.call(this, productData.blockElements[this.currentStep]);

                Promise.all(promises)
                    .then(() => {
                        this.updateData(productData);

                        if ( !triggerIsListItemChange ) {

                            const colorBlock = productData.blockElements[this.currentStep].blockElements.find(function(blockElement) {
                                return blockElement.name === "ProductColour" || blockElement.name === "FabricColour1"
                            });

                            const secondColorBlock = productData.blockElements[this.currentStep].blockElements.find(function(blockElement) {
                                return blockElement.name === "FabricColour2"
                            });

                            if (colorBlock && !secondColorBlock ) {
                                // only one fabric color available
                                const selectedFirstColor = colorBlock.options.find(function(color){
                                    return color.selected;
                                });

                                if (selectedFirstColor) {
                                    this.setMainBackgroundColor(selectedFirstColor.data.average_color, 1);
                                    this.mainImgBackgroundColorSecond = null;
                                }
                            }

                            if ( colorBlock && (secondColorBlock && secondColorBlock.isEnabled) ) {
                                // second fabric color available
                                const selectedFirstColor = colorBlock.options.find(function(color){
                                    return color.selected;
                                });

                                if (selectedFirstColor) {
                                    this.setMainBackgroundColor(selectedFirstColor.data.avarage_color, 1);
                                    this.mainImgBackgroundColorSecond = null;
                                }

                                const selectedSecondColor = secondColorBlock.options.find(function(color){
                                    return color.selected;
                                });

                                if (selectedSecondColor) {
                                    this.setMainBackgroundColor(selectedSecondColor.data.average_color, 2);
                                }
                            }
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        this.isLoading = false;
                        this.isLoadingFirstTime = false;
                    });

                // Add content to contentItems
                function fetchBlockData(blockElement) {
                    if (blockElement.contentItems) {
                        blockElement.contentItems.forEach((contentItem, index) => {
                            promises.push(new Promise((resolve, reject) => {
                                api.getContentProviderData(contentItem.contentProvider.url)
                                    .done(data => {
                                        if (data ) {
                                            contentItem.data = data;
                                        } else {
                                            contentItem.data = blockElement.label;
                                        }
                                    })
                                    .fail(e => {
                                        contentItem.data = blockElement.label;
                                    })
                                    .always(data => {
                                        resolve(true);
                                    });
                            }));
                        });
                    }

                    if (blockElement.itemType === 'ListProperty') {

                        if (blockElement.options.length > 0) {

                            if (blockElement.options[0].contentItems) {

                                let url = blockElement.options[0].contentItems[0].contentProvider.url;

                                url = url.replace(/\/(Property|Option)\/([^\/]+)\/.*$/, function($1, $2, $3) {
                                    return '/Option/' + $3 + '/GetAll';
                                });

                                promises.push(new Promise((resolve, reject) => {
                                    api.getContentProviderData(url)
                                        .done(data => {
                                            if ( data ) {
                                                blockElement.optionsData = Object.values(data);
                                                blockElement.options.forEach(option => {
                                                    option.data = blockElement.optionsData.find(optionData => {
                                                        var parameter = option.contentItems[0].parameterValues.find(parameterValue => parameterValue.name === 'Value');
                                                        if ( typeof parameter !== 'undefined' ) {
                                                            return parameter && parameter.value === optionData.value;
                                                        } else {
                                                            return option.contentItems[0].parameterValues[0].value === optionData.value;
                                                        }
                                                    });

                                                    if (!option.data) {
                                                        // option.data = {}
                                                        option.data = {
                                                            value: option.displayValue,
                                                            title: option.displayValue
                                                        }
                                                    }
                                                })
                                            } else {
                                                blockElement.options.forEach(option => {
                                                    // if there are no content providers fall back on displayValue from HD api
                                                    option.data = {
                                                        value: option.displayValue,
                                                        title: option.displayValue
                                                    }
                                                });
                                            }

                                            resolve();
                                        })
                                        .fail(e => {
                                            blockElement.options.forEach(option => {
                                                // if there are no content providers fall back on displayValue from HD api
                                                option.data = {
                                                    value: option.displayValue,
                                                    title: option.displayValue
                                                }
                                            });
                                            // reject('GetAll call error');
                                        }).always(data => {
                                            resolve(true);
                                        });
                                }));
                            } else {
                                blockElement.options.forEach((option) => {
                                    option.data = {
                                        value: option.displayValue,
                                        title: option.displayValue
                                    }
                                })
                            }
                        }
                    }

                    if (blockElement.blockElements) {
                        blockElement.blockElements.forEach(fetchBlockData.bind(this))
                    }
                }
            },
            updateData(productData) {

                // Empty block array
                this.content.blocks = [];

                // Overview data handling
                const summaryBlock = productData.blockElements.find(blockElement => blockElement.name === 'summary')

                summaryBlock.blockElements = productData.summary.summaryBlockElements.map(summaryBlockElement => {

                    const blockElement = productData.blockElements.find(blockElement => blockElement.name === summaryBlockElement.name);

                    return {
                        title: blockElement.title,
                        description: null,
                        name: summaryBlockElement.name,
                        itemType: 'SummaryBlock',
                        summaryItems: summaryBlockElement.summaryBlockElements.map(item => {

                            // Custom data for overview
                            item.title = item.name;
                            const tempId = item.blockElementId.replace('//', '_');
                            const tempVar = blockElement.blockElements.find(blockElement => blockElement.id === tempId);

                            if ( tempVar && tempVar.title ) {
                                item.title = tempVar.title;
                            }

                            if ( typeof item.value === 'string' && item.value.indexOf('<sup>®</sup>') === -1 ) item.value = item.value.replace(/®/g, '<sup>®</sup>');

                            if (item.itemType === 'BooleanProperty') {
                                if (item.value === true) {
                                    item.value = 'Ja'
                                } else if (item.value === false) {
                                    item.value = 'Nee'
                                }
                            }

                            return item
                        })
                    }
                })

                summaryBlock.blockElements.push({
                    title: null,
                    description: null,
                    name: 'SummaryPriceBlock',
                    itemType: 'SummaryPriceBlock'
                })

                updateBlockData.call(this, productData.blockElements[this.currentStep]);

                function updateBlockData(blockElement) {

                    if (blockElement.contentItems) {
                        blockElement.title = blockElement.contentItems.find((contentItem) => contentItem.type === 'Text');
                        if (blockElement.title) {
                            blockElement.title = blockElement.title.data;
                            blockElement.title = blockElement.title.replace(/®/g, '<sup>®</sup>');
                        }

                        blockElement.description = blockElement.contentItems.find((contentItem) => contentItem.type === 'Html');
                        if (blockElement.description) {
                            blockElement.description = blockElement.description.data;
                            blockElement.description = blockElement.description.replace(/®/g, '<sup>®</sup>');
                        }
                    }

                    if (!blockElement.title) blockElement.title = null;
                    if (!blockElement.description) blockElement.description = null;

                    if (blockElement.itemType === 'ListProperty') {

                        blockElement.listClass = 'option-list--small';

                        blockElement.options.forEach(option => {
                            // Create unique id for list propery items
                            option.id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

                            option.selected = option.key === blockElement.value ? true : false;

                            if (option.data.title) {

                                option.data.title = option.data.title.replace(/®/g, '<sup>®</sup>');

                                if (option.data.title.length > 8) {
                                    blockElement.listClass = 'option-list--large'
                                }
                            }
                        })
                    }

                    const savedBlock = this.content.savedBlocks.find(block => block.id === blockElement.id)
                    if (!savedBlock) {
                        this.content.savedBlocks.push({
                            id: blockElement.id,
                            title: blockElement.title,
                            description: blockElement.description,
                            visited: blockElement.visited
                        })
                    }

                    if (blockElement.isEnabled !== false) {
                        this.content.blocks.push(blockElement);
                    }

                    if (blockElement.blockElements) {
                        blockElement.blockElements.forEach(updateBlockData.bind(this))
                    }
                }


                window.setTimeout(() => {
                    this.isUpdatingStep = false;
                }, 400)

                this.isLoading = false;
                this.isLoadingFirstTime = false;
                this.productData = productData;
            },
            onInputChange(event, block, option) {
                this.isLoading = true;
                const value = event.target.value;
                const id = option ? block.id : event.target.id;
                option ? block.value = option.key : block.value = value;

                if (option) {
                    block.options.forEach(optionItem => {
                        optionItem.selected = false;
                    })
                    option.selected = true;
                }

                if (
                    event.target.getAttribute("name") === "FabricColour1" || event.target.getAttribute("name") === "ProductColour") {
                    this.setMainBackgroundColor(option.data.average_color, 1);
                }

                if (
                    event.target.getAttribute("name") === "FabricColour2") {
                    this.setMainBackgroundColor(option.data.average_color, 2);
                }

                const url = api.settings.serviceUrl + api.settings.serviceUrlSET + '?id=' + id + '&value=' + value;
                api.getProductData(url, 'PUT', this.oAuthToken).then(productData => {
                    this.updateProductData(productData, true);
                });
            },
            mainImgLoaded() {
                this.mainImgLoading = false;
            },
            onRoomChange(event, id) {
                if (!id) id = event.target.id;
                const value = parseInt(event.target.value);

                this.roomOptions.forEach(option => {
                    if ( option.key === id ) {
                        option.selected = true;
                        this.selectedRoomIndex = value;
                        this.changeMainImage();
                    } else {
                        option.selected = false;
                    }
                });
            },
            onRoomColorChange(color) {
                this.roomColorOptions.forEach(option => {
                    if ( option.color === color ) {
                        this.selectedRoomColor = color;
                        this.changeMainImage();
                        option.selected = true;
                    } else {
                        option.selected = false;
                    }
                });
            },
            openContentModal(event) {
                this.modal.image    = event.target.dataset.image;
                this.modal.video    = event.target.dataset.video;
                this.modal.html     = event.target.dataset.html;
                this.modal.isOpen   = true;
            },
            changeMainImage() {
                this.mainImgLoading = true;
                const roomImage = this.product.rooms.rooms[this.selectedRoomIndex].colors.find((currentColor) => currentColor.color === this.selectedRoomColor).mainImage;
                this.product.selectedImage = roomImage;
            },
            toggleSelectorPanel() {
                this.selectorPanelIsOpen = !this.selectorPanelIsOpen;
            },
            submitMailForm(event) {
                event.preventDefault();

                let data = {
                    'json': this.json,
                    'address': this.mailAddressee,
                    'product_id': this.product.ID
                };

                api.sendMail(data, this.mailUrl)
                    .done(response => {
                        this.mailResponse = true;

                        // Dit is de versie voor als we respons krijgen van onze api
                        this.mailResponseContent = {
                            title: response.title,
                            message: response.content,
                            btnText: response.btnText,
                            success: response.success
                        }
                    })
                    .fail(response => {
                        console.log('form submit failed');
                    })
            },

        },
        created() {
            $.ajax(process.env.BASE_URL + 'environment.json', {
                crossDomain: true,
                method: 'GET',
                success: (response) => {
                    // resolve(response);
                    api.getInitialData(response.initialDataUrl).then((data) => {
                        this.staticContent = {...data.labels};
                        this.mailUrl = data.mailUrl;

                        if (data.products.length > 0) {
                            data.products.forEach(product => {
                                product.productTitle = product.productTitle.replace(/®/g, '<sup>®</sup>');
                            });
                            this.initialProductData = data.products;
                            this.init();
                        }
                    });
                },
                error: function() {
                    // resolve('');
                }
            });
        }
    }
</script>
<style lang="scss" scoped>
    @import "./src/styles/generic/settings";
    @import "./src/styles/components/selector-panel";
    @import "./src/styles/components/product-selector";
    @import "./src/styles/components/room-selector";
</style>
